import { Directive, ElementRef, Input, NgModule } from '@angular/core';

@Directive({
  selector: '[appSystemModal]',
})
export class ModalDirective {
  @Input() dragHandle!: string;
  private element: HTMLElement;

  constructor(private elementRef: ElementRef) {
    this.element = this.elementRef.nativeElement as HTMLElement;
  }

  ngOnInit() {
    let isDragging = false;
    let currentX: number;
    let currentY: number;
    let initialX: number;
    let initialY: number;
    let xOffset = 0;
    let yOffset = 0;

    const dragStart = (e: MouseEvent) => {
      initialX = e.clientX - xOffset;
      initialY = e.clientY - yOffset;

      if (e.target === this.element.querySelector(this.dragHandle)) {
        isDragging = true;
      }
    };

    const dragEnd = () => {
      initialX = currentX;
      initialY = currentY;
      isDragging = false;
    };

    const drag = (e: MouseEvent) => {
      if (isDragging) {
        e.preventDefault();
        currentX = e.clientX - initialX;
        currentY = e.clientY - initialY;
        xOffset = currentX;
        yOffset = currentY;
        this.setTranslate(currentX, currentY, this.element);
      }
    };

    this.element.addEventListener('mousedown', dragStart);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', dragEnd);
  }

  setTranslate(xPos: number, yPos: number, el: HTMLElement) {
    el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
  }
}

@NgModule({
  declarations: [ModalDirective],
  exports: [ModalDirective],
})
export class SystemModalDirectiveModule {}
